import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbTime: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z' />
          <polygon points='12 11 8 7 6.5 8.5 12 14 16 10 14.5 8.5 12 11' />
        </g>
      </svg>
    </>
  );
};
